import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { useFirstConsultationVersionsQuery } from '@/hooks/useFirstConsultationVersionsQuery';
import { formatIsoDateTimeToTimestamp } from '@/utils/dateFormatting';

interface ConsultationVersionsListProps {
  consultationId: string;
}

export function ConsultationVersionsList({ consultationId }: ConsultationVersionsListProps) {
  const { t } = useTranslation('consultations');
  const versionsQuery = useFirstConsultationVersionsQuery(consultationId);
  const versions = versionsQuery.data === undefined ? [] : versionsQuery.data;

  return (
    <div>
      <p className="text-xs font-bold text-zooindigo mb-2">{t('sharing.versionsTitle')}</p>
      {versionsQuery.isLoading ? (
        <LoadingSpinner className="w-4 h-4" />
      ) : versions.length === 0 ? (
        <p className="text-xs text-zoomuted">{t('sharing.versionsEmpty')}</p>
      ) : (
        <ul className="space-y-1 max-h-40 overflow-y-auto">
          {versions.map(function renderVersion(version) {
            return (
              <li key={version.versionNumber} className="text-xs text-zoomuted">
                <span className="font-semibold text-zooindigo">
                  {t('sharing.versionLabel', { number: version.versionNumber })}
                </span>
                {' · ' + formatIsoDateTimeToTimestamp(version.recordedAt)}
                {version.recordedByName === null
                  ? ''
                  : ' ' + t('sharing.versionRecordedBy', { name: version.recordedByName })}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
